<div class="navy-background h-100">
  <app-messaging-sidebar-header></app-messaging-sidebar-header>  
  <perfect-scrollbar style="height: calc(100% - 52px);">
    <app-messaging-sidebar-channels></app-messaging-sidebar-channels>
    <hr class="divider mx-3"/>
    <app-messaging-sidebar-conversations></app-messaging-sidebar-conversations>
  </perfect-scrollbar>
</div>
